<template functional>
  <div>
    <el-popover
      v-if="
        data.attrs.row[data.attrs.column] != null &&
        data.attrs.row[data.attrs.column].length > 60
      "
      title="Mensaje Completo"
      :content="data.attrs.row[data.attrs.column]"
      trigger="hover"
      placement="top"
      style="cursor: pointer"
      width="500"
      offset="-140"
    >
      <span slot="reference"
        >{{ data.attrs.row[data.attrs.column].substring(0, 60) }}...</span
      >
    </el-popover>

    <span v-else>{{ data.attrs.row[data.attrs.column] }}</span>
  </div>
</template>

<script>
export default {
  name: "ComplaintDescriptionFormatter"
};
</script>
